import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

interface ServiceLink {
  label: string;
  path: string;
}

interface Props {
  links: ServiceLink[];
  heading?: string;
}

export default function RelatedServicesBlockService({ links, heading }: Props) {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-[#fefce8] py-12 md:py-16">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-[#064e3b] text-center mb-8">
          {heading || t("common.relatedServicesH2")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-[720px] mx-auto">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="block bg-white rounded-lg border-l-4 border-[#064e3b] p-4 hover:bg-white/80 transition-colors"
            >
              <p className="text-sm font-bold text-[#064e3b]">{link.label}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}